export const enum RouteEndType {
  HEALTHCARE_FACILITY = 'HEALTHCARE_FACILITY',
  VILLAGE = 'VILLAGE',
}
